const parseStringWithDefaultValue = (
  value: string | undefined | null,
  standard: string,
) => {
  if (value !== undefined && value !== null) {
    if (!value.includes("##")) {
      return value;
    }
  }

  return standard;
};

export { parseStringWithDefaultValue };
